import React, { useMemo, ReactNode } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import { cn } from "@/lib/utils";

// Common SVG icon paths
const ICONS = [
  {
    path: '<path d="M9.5.5a.489.489 0 0 0-.22.05L3.5 2a.5.5 0 0 0-.5.5v4.59A1.5 1.5 0 1 0 4 8.5V5.38l5-1.25v1.46A1.5 1.5 0 1 0 10 7V1a.5.5 0 0 0-.5-.5zM4 4.38v-1.5l5-1.25v1.5L4 4.38z" fill="currentColor"/>',
    viewBox: "0 0 12 12"
  },
  {
    path: '<path d="M6.65 2C5.43 2 4.48 3.38 4.11 3.82a.5.5 0 0 0-.11.32v4.4a.44.44 0 0 0 .72.36a3 3 0 0 1 1.93-1.17C8.06 7.73 8.6 9 10.07 9a5.3 5.3 0 0 0 2.73-1.09a.49.49 0 0 0 .2-.4V2.45a.44.44 0 0 0-.62-.45a5.75 5.75 0 0 1-2.31 1.06C8.6 3.08 8.12 2 6.65 2M2.5 3a1 1 0 1 1 0-2a1 1 0 0 1 0 2M3 4v9.48a.5.5 0 0 1-1 0V4a.5.5 0 0 1 1 0"/>',
    viewBox: "0 0 14 14"
  },
  {
    path: '<path d="M7.53 3C3.09 3 1 7.5 1 7.5S3.09 12 7.53 12S14 7.5 14 7.5S12 3 7.53 3M11 7v1.5a.5.5 0 0 1-1 0V8H8v.5a.5.5 0 0 1-1 0V8H5v.5a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0V7h2v-.5a.5.5 0 0 1 1 0V7h2v-.5a.5.5 0 0 1 1 0z"/>',
    viewBox: "0 0 15 15"
  },
  {
    path: '<path d="M7.528.895L9 2h1L11.473.896a.33.33 0 0 1 .527.263V4.5c0 .722-.522 1.184-1 1.573V10l.8 2.4l.706.353a.89.89 0 0 1 .494.8c0 .247-.2.447-.447.447H4.25C3.017 14 2 13 2 11.713c0-2.17.453-3.783.745-4.868c.146-.543.29-.95.393-1.231c.058-.157.115-.303.192-.449c.449-.855 1.744-.21 1.342.668a6 6 0 0 0-.133.317c-.091.232-.214.593-.346 1.084c-.246.915-.519 2.287-.635 4.133c.368-2.06 2.422-4.128 4.077-5.609c-.345-.326-.634-.72-.634-1.258V1.158c0-.27.31-.425.527-.263"/>',
    viewBox: "0 0 14 14"
  },
  {
    path: '<path d="M6.5 6.4V6l4.5.5V5L6.5 3.2V1.5C6.5.5 6 0 5.5 0s-1 .5-1 1.5v1.7L0 5v1.4L4.5 6v3.3L3 10v1l2.5-.5L8 11v-1l-1.5-.8V6.4z"/>',
    viewBox: "0 0 11 11"
  },
  {
    path: '<path d="M12 2 L15.09 8.26 L22 9.27 L17 14.14 L18.18 21.02 L12 17.77 L5.82 21.02 L7 14.14 L2 9.27 L8.91 8.26 L12 2 Z"/>',
    viewBox: "0 0 24 24"
  },
  {
    path: '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>',
    viewBox: "0 0 24 24"
  },
  {
    path: '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>',
    viewBox: "0 0 24 24"
  },
  {
    path: '<path d="M7.5 1C5.423 1 3 2.288 3 5.568C3 7.793 6.462 12.712 7.5 14c.923-1.288 4.5-6.09 4.5-8.432C12 2.288 9.577 1 7.5 1"/>',
    viewBox: "0 0 15 15"
  },
  {
    path: '<path d="M5.488 1C4.976 1 .5 1 1 1.5L5 6v2.5C5 9 2.5 9 2.5 10h6C8.5 9 6 9 6 8.5V6l4-4.5C10.5 1 6 1 5.488 1zM2.5 2h6l-1 1h-4l-1-1z"/>',
    viewBox: "0 0 11 11"
  },
  {
    path: '<path d="M13.91 7.75c-1.17 2.25-4.3 5.31-6.07 6.94a.5.5 0 0 1-.67 0C5.39 13.06 2.26 10 1.09 7.75C-1.48 2.8 5-.5 7.5 4.45C10-.5 16.48 2.8 13.91 7.75"/>',
    viewBox: "0 0 15 15"
  },
  {
    path: '<path d="m12.6 8.7l-1.1-2.2a1.05 1.05 0 0 0-.9-.5H4.4a1.05 1.05 0 0 0-.9.5L2.4 8.7L1.16 9.852a.5.5 0 0 0-.16.366V14.5a.5.5 0 0 0 .5.5h2c.2 0 .5-.2.5-.4V14h7v.5c0 .2.2.5.4.5h2.1a.5.5 0 0 0 .5-.5v-4.282a.5.5 0 0 0-.16-.366ZM4.5 7h6l1 2h-8Zm.5 4.6c0 .2-.3.4-.5.4H2.4c-.2 0-.4-.3-.4-.5v-1.1c.1-.3.3-.5.6-.4l2 .4c.2 0 .4.3.4.5Zm8-.1c0 .2-.2.5-.4.5h-2.1c-.2 0-.5-.2-.5-.4v-.7c0-.2.2-.5.4-.5l2-.4c.3-.1.5.1.6.4ZM8 4H7L6 0h3ZM1.1 1.8L3.7.3l1.1 4l-.8.4ZM11.3.3l2.6 1.5l-2.9 3l-.9-.5Z"/>',
    viewBox: "0 0 15 15"
  }
];

interface TimeButtonProps {
  value: string;
  player: any;
}

interface CustomMarkdownProps {
  markdown: string;
  className?: string;
  fontSize?: number;
  lineHeight?: number;
  player?: any;
  showTimeButtons?: boolean;
}

const TimeButton: React.FC<TimeButtonProps> = ({ value, player }) => {
  const formatTimeDisplay = (timeString: string) => {
    const totalSeconds = parseFloat(timeString);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const handleClick = () => {
    const timeInSeconds = parseFloat(value);
    if (!isNaN(timeInSeconds) && player) {
      try {
        player.seekTo(timeInSeconds, true);
        player.playVideo();
      } catch (error) {
        console.error('Error seeking video:', error);
      }
    }
  };

  return (
    <button 
      onClick={handleClick}
      className="space-x-2 px-1.5 h-6 bg-orange-500 text-white rounded-full shadow-lg hover:bg-orange-400 hover:text-white transition duration-300 inline-flex items-center"
    >
      <span className="flex items-center gap-1">
        <svg 
          width="15" 
          height="15" 
          viewBox="0 0 15 15" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-4 w-4 opacity-60"
        >
          <path 
            d="M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z" 
            fill="white" 
            stroke="white" 
            strokeWidth="0.5" 
            fillRule="evenodd" 
            clipRule="evenodd"
          />
        </svg>
        <span>{formatTimeDisplay(value)}</span>
      </span>
    </button>
  );
};

const CustomMarkdown: React.FC<CustomMarkdownProps> = ({ 
  markdown, 
  className = "",
  fontSize = 16,
  lineHeight = 1.6,
  player,
  showTimeButtons = true
}) => {
  // 首先处理单下划线的文本，将其转换为标准的 markdown 斜体语法
  const processedMarkdown = useMemo(() => {
    return markdown.replace(/(?<!\\)_(.+?)(?<!\\)_/g, '*$1*');
  }, [markdown]);

  // New deterministic icon selection based on text content
  const listItemIcons = useMemo(() => new Map<string, number>(), []);

  const getIconForText = (text: string) => {
    if (!listItemIcons.has(text)) {
      const randomIndex = Math.floor(Math.random() * ICONS.length);
      listItemIcons.set(text, randomIndex);
    }
    return ICONS[listItemIcons.get(text)!];
  };

  const components: Components = {
    h1: ({ children }: { children?: ReactNode }) => (
      <h1 
        className="font-extrabold mb-6 dark:text-primary-foreground leading-tight" 
        style={{ 
          fontSize: `${fontSize + 14}px`, 
          lineHeight: Math.max(lineHeight * 0.9, 1.2)
        }}
      >
        {children}
      </h1>
    ),
    h2: ({ children }: { children?: ReactNode }) => (
      <h2 
        className="font-extrabold mb-5 dark:text-primary-foreground leading-tight" 
        style={{ 
          fontSize: `${fontSize + 10}px`, 
          lineHeight: Math.max(lineHeight * 0.9, 1.2)
        }}
      >
        {children}
      </h2>
    ),
    h3: ({ children }: { children?: ReactNode }) => (
      <h3 
        className="font-bold mb-4 dark:text-primary-foreground leading-tight" 
        style={{ 
          fontSize: `${fontSize + 6}px`, 
          lineHeight: Math.max(lineHeight * 0.9, 1.2)
        }}
      >
        {children}
      </h3>
    ),
    p: ({ children }: { children?: ReactNode }) => (
      <p 
        className="mb-4 transition-colors dark:text-primary-foreground text-foreground/90" 
        style={{
          fontSize: `${fontSize}px`,
          lineHeight: lineHeight,
        }}
      >
        {children}
      </p>
    ),
    li: ({ children }: { children?: ReactNode }) => {
      const content = children?.toString() || '';
      const icon = getIconForText(content);
      
      return (
        <li className="flex items-start mb-3">
          <span className="inline-block mr-3 mt-1 flex-shrink-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={Math.max(16, fontSize * 0.9)}
              height={Math.max(16, fontSize * 0.9)}
              viewBox={icon.viewBox}
              className="text-primary"
              fill="currentColor"
              dangerouslySetInnerHTML={{ __html: icon.path }}
            />
          </span>
          <span 
            style={{
              fontSize: `${fontSize}px`,
              lineHeight: lineHeight
            }} 
            className="flex-1 transition-colors dark:text-primary-foreground text-foreground/90"
          >
            {children}
          </span>
        </li>
      );
    },
    em: ({ children }: { children?: ReactNode }) => (
      <span 
        style={{ 
          fontSize: `${Math.max(fontSize * 0.95, 14)}px`,
          lineHeight: lineHeight
        }} 
        className="inline italic bg-primary/10 text-primary border border-primary/20 px-2 py-0.5 rounded-md font-medium"
      >
        {children}
      </span>
    ),
    strong: ({ children }: { children?: ReactNode }) => (
      <strong 
        className="font-bold text-foreground dark:text-primary-foreground" 
        style={{ lineHeight: lineHeight }}
      >
        {children}
      </strong>
    ),
    code: ({ children }: { children?: ReactNode }) => {
      const timeValue = children?.toString() || '';
      if (/^\d+(\.\d+)?$/.test(timeValue) && showTimeButtons && player) {
        return <TimeButton value={timeValue} player={player} />;
      }
      return (
        <code 
          className="bg-muted px-1.5 py-0.5 rounded text-sm font-mono border" 
          style={{ fontSize: `${Math.max(fontSize * 0.85, 12)}px` }}
        >
          {children}
        </code>
      );
    },
  };

  return (
    <div className={cn("dark:prose-dark", className)}>
      <ReactMarkdown components={components}>
        {processedMarkdown || ''}
      </ReactMarkdown>
    </div>
  );
};

export default CustomMarkdown;